"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFlameRating64High = function SvgFlameRating64High(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flame-rating-64-high_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00E04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00B0B6"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#flame-rating-64-high_svg__a) #00c48c",
    d: "M29.96 56.973C16.646 56.495 6 45.551 6 32.121 6 18.39 17.13 7.256 30.862 7.253l.003-.136c8.023-.588 11.507-4.774 11.507-4.774s.82 2.66 1.075 6.753A29.124 29.124 0 0 0 44.8 7.69c2.032-2.293 3.63-4.864 4.479-7.69 0 0 9.095 7.746 5.778 25.069 3.2-.872 3.731-4.772 3.827-7.948 1.976 4.152 6.78 41.421-28.924 39.872v-.02z",
    opacity: 0.9,
    fillRule: "evenodd"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgFlameRating64High);
var _default = exports["default"] = Memo;